export default __webpack_public_path__ + "static/media/myLocation.733165f1.svg";